//@flow
import React from 'react';

type Props = {};

export default class SplashPage extends React.Component<Props> {
  render() {
    return (
      <div className={'proc-splash-page'}>
        <div className={'proc-outer'}>
          <div className={'contents'}>
            <img className="splash-image image" src={'/images/pages/top/splash_screen@3x.png'} />
          </div>
          <div className={'proc-footer copyright'}>
            <div className="logo-image image" />
            <div className={'copyright'}>©2019 Sony Global Education, Inc.</div>
            <img className={'image loading-image'} src={'/images/pages/top/loading@3x.png'} />
          </div>
        </div>
      </div>
    );
  }
}
